import { render, staticRenderFns } from "./LicenseSelector.vue?vue&type=template&id=095af666"
import script from "./LicenseSelector.vue?vue&type=script&lang=js"
export * from "./LicenseSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports